import ModuleMarginWrapper from "./wrappers/ModuleMarginWrapper";
import PropTypes from "prop-types";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";
import Wysiwyg from "theme/libs/wordpress/components/Wysiwyg";
import { above } from "core-web/utils/mediaqueries";
import styled from "theme/libs/styled";
import { wysiwygProp } from "core-web/utils/proptypes/modules/textProps";

const StyledModuleMarginWrapper = styled(ModuleMarginWrapper)`
    max-width: 513px;
    margin-bottom: 64px;

    ${above.tabletLg} {
        margin-bottom: 104px;
    }
`;

const Ul = styled("ul")`
    margin: 40px 0;
    & > li {
        margin-left: 1em;
    }
`;

const LongerDescription = ({ heading, description }) => {
    return (
        <StyledModuleMarginWrapper className="long-description">
            {!!heading?.length && (
                <TextStyles
                    as="h2"
                    textStyles={["Myriad Pro/32-120-semibold", null, null, null, null, "Myriad Pro/40-120-semibold"]}
                    mb="48px"
                >
                    {heading[0]}
                </TextStyles>
            )}

            <Wysiwyg
                data={description}
                tagComponents={{ ul: Ul }}
                textComponent={(props) => <TextStyles mb="1.5rem" textStyles="Myriad Pro/20-140" {...props} />}
            />
        </StyledModuleMarginWrapper>
    );
};

LongerDescription.propTypes = {
    heading: PropTypes.string,
    description: wysiwygProp.isRequired,
};

export default LongerDescription;
